import { Tag } from "../api/model";
import TagGroup from "../api/model/barrels/TagGroup";
import Barrel from "../model/Barrel";
import BasicRecord from "./BasicRecord";
import { getNewFractionalOrder, sortByOrder } from "./indexing";
import { sortBy } from "./sortBy";

export enum TagTypes {
    screen = "screen",
    member = "member",
    status = "status",
    default = "default"
}

export function getTagType(tagGroup: TagGroup) {
    if (tagGroup.type) {
        return TagTypes[tagGroup.type];
    }
    return TagTypes.default;
}

export function getSortedTagsByName(barrelTags: Tag[], tagGroup: TagGroup) {
    const tagsMapped: BasicRecord<Tag> = barrelTags.reduce(
        (acc, tag) => ({ ...acc, [tag._id]: tag }),
        {}
    );
    const tagGroupTags = tagGroup.tags?.map(tagId => tagsMapped[tagId]) || [];
    return tagGroupTags!.sort(sortBy.name);
}

export function getSortedTagsByOrder(barrelTags: Tag[], tagIds: string[]) {
    const tagsMapped: BasicRecord<Tag> = barrelTags.reduce(
        (acc, tag) => ({ ...acc, [tag._id]: tag }),
        {}
    );

    return tagIds.sort((a, b) => {
        const tagA = tagsMapped[a];
        const tagB = tagsMapped[b];

        return sortByOrder(tagA, tagB);
    });
}

export function getAlphaOrderForTag(barrel: Barrel, tagData: Partial<Tag>, tid: string, tagGroup: TagGroup) {
    const tagsMapped = barrel.tags!.reduce<Record<string, Tag>>((acc, tag) => ({ ...acc, [tag._id]: tag }), {});
    const tagGroupTags = tagGroup.tags?.map(tagId => tagsMapped[tagId]).filter(({ _id }) => _id !== tid) ?? [];
    const placeBefore = tagGroupTags.findIndex(({ name }) => name.toLowerCase() >= tagData.name!.toLowerCase());
    const index = placeBefore === -1 ? tagGroupTags.length : placeBefore;
    const { order } = getNewFractionalOrder(tid, index, tagGroupTags);
    return order;
}
